import request from 'assets/js/http';
export const queryByName = name => {
  return request({
    url: '/humint/queryByName',
    method: 'post',
    data: {
      name: name
    }
  });
};
export const createTask = data => {
  return request({
    url: '/humint/createTask',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data
  });
};
export const queryMyTask = data => {
  return request({
    url: '/humint/myHumint',
    method: 'post',
    data: data
  });
};

export const queryFeedbackInfo = data => {
  return request({
    url: '/humint/queryFeedbackInfo',
    method: 'post',
    data: data
  });
};
export const commitFeedbackInfo = data => {
  return request({
    url: '/humint/commitFeedbackInfo',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data
  });
};
export const toMeList = data => {
  return request({
    url: '/humint/recommendToMeList',
    method: 'post',
    data: data
  });
};
export const myRecommendList = data => {
  return request({
    url: '/humint/myRecommendList',
    method: 'post',
    data: data
  });
};
export const recommend = data => {
  return request({
    url: '/humint/recommend',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data
  });
};
export const commitProgress = data => {
  return request({
    url: '/humint/commitProgress',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data
  });
};
export const queryRecommendData = data => {
  return request({
    url: '/humint/queryRecommendData',
    method: 'post',
    data: data
  });
};
